import * as React from "react"
import { I18nService } from "../../services/utils/i18n.service"

interface Props {
  presentation?: 'block' | 'inline'
  align?: 'center' | 'left'
  compact?: boolean
  message?: string
  loadingIconStyle?: React.CSSProperties
}

const i18nScoped = new I18nService(require('./loading.component.yml'))

export default function LoadingComponent ({ presentation, align, message, compact, loadingIconStyle = { display: 'inline-block' } }: Props) {
  const refinedLoadingIconStyle = { ...loadingIconStyle }
  if (compact) refinedLoadingIconStyle.height = '1rem'

  if (presentation === 'inline') {
    return <div className="iconLoading-container" style={{ display: 'flex', justifyContent: align, alignItems: 'center' }}>
      <div className="iconLoading" style={ refinedLoadingIconStyle }></div>
      <div className="iconLoading-message">{ message || i18nScoped.t('loading') }</div>
    </div>
  }

  return <div className={ `iconLoading-container ${ align === 'center' ? 'u-txtCenter' : '' }` }>
    <div className="iconLoading" style={ refinedLoadingIconStyle }></div>
    <div className="iconLoading-message">{ message || i18nScoped.t('loading') }</div>
  </div>
}
